import React from 'react';
import '../styles/main.css';

function Contact() {
    return (
        <a href="/Contact">Contact</a>
    );
}

export default Contact;